import type { WPVideoProps } from './types';
import { WPVideo as WPVideoClient } from './WPVideoClient';

export function WPVideo({ props, type, version }: WPVideoProps) {
  return <WPVideoClient props={props} type={type} version={version} />;
}
